<form class="mt-5" [formGroup]="offerForm" (ngSubmit)="confirmOffer()">
  <fieldset>
    <legend class="mb-4">Please select one payment option:</legend>
    <div class="d-md-flex align-items-center">
      <div class="radio-control">
        <input
          type="radio"
          name="offersMap"
          id="payment-option-1"
          formControlName="offersMap"
          [value]="offer().offerTraits[0].traitId"
        />
        <label for="payment-option-1">{{ offer().offerTraits[0].name }}</label>
      </div>

      <div class="radio-control mt-3 mt-md-0">
        <input
          type="radio"
          name="offersMap"
          id="payment-option-2"
          formControlName="offersMap"
          [value]="offer().offerTraits[1].traitId"
        />
        <label for="payment-option-2">{{ offer().offerTraits[1].name }}</label>
      </div>
    </div>
  </fieldset>

  <div class="grid-controls-wrapper mt-4">
    <div class="name-control">
      <label for="name">Name</label>
      <input type="text" id="name" formControlName="userName" appTrimSpaces />
    </div>

    <div class="role-control">
      <label for="role">Role</label>
      <input type="text" id="role" formControlName="userRole" appTrimSpaces />
    </div>

    <div class="email-control">
      <label for="role">Email</label>
      <input type="email" id="email" formControlName="email" />
    </div>

    <div class="checkbox-control auth-control">
      <input
        type="checkbox"
        name="authorizeOffer"
        id="authorization"
        formControlName="authorizeOffer"
      />
      <label for="authorization">
        By clicking Accept, I confirm that I have reviewed the offer, including
        the T&Cs, and that I am authorized to accept the offer on behalf of the
        Organization.
      </label>
    </div>
  </div>

  <button class="btn-primary mt-4 submit-btn" [disabled]="!offerForm.valid">
    Accept offer
  </button>
</form>
